// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{display:flex;flex-flow:column nowrap;width:100vw;height:100vh;overflow:hidden}::-webkit-scrollbar{background-color:#fff;width:6px;height:6px;background-clip:padding-box}::-webkit-scrollbar-button{height:0;width:0}::-webkit-scrollbar-thumb{background-color:#b9b9bd;border-radius:3px}", ""]);
// Exports
module.exports = exports;
